import { type SortColumn } from 'owa-mail-list-store';
import type ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

/**
 * Returns the required ReactListViewType for a given sort column.
 * @param sortColumn The sort column to get the required ReactListViewType for.
 * @returns The required ReactListViewType or null if none is required.
 */
function getRequiredReactListViewTypeForSort(
    sortColumn: SortColumn | undefined
): ReactListViewType | null {
    if (!sortColumn) {
        return null;
    }

    switch (sortColumn) {
        case 14:
        case 6:
        case 8:
            return 1;
    }

    // No specific ReactListViewType required for the given sort column
    return null;
}

export { getRequiredReactListViewTypeForSort };
